import React, { useEffect, useRef } from "react";
import { connect, ConnectedProps } from "react-redux";

import { openDialog, openTooltip } from "../../../../store/actions";
import { TILE_TYPE_NAMES, tileType } from "../../../../lib/enums";
// import Slot from "./Slot";
import TileDiv from "./TileDiv";
import SlotPerson from "./SlotPerson";
import { TileType } from "../../../../lib/types";
import { setSameHeight } from "../../../../lib/elementUtilities";

const mapStateToProps = (state: any) => ({
  resources: state.governorate.resources,
  tiles: state.governorate.tiles,
  tilePrices: state.governorate.tilePrices,
  slotPrices: state.governorate.slotPrices,
  allBuildings: state.governorate.allBuildings,
  war: state.governorate.war,
  freePops: state.governorate.population.free
})

const mapDispatchToProps = (dispatch: any) => ({
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions)),
  openTooltipDispatch: (tooltipOptions: any) => dispatch(openTooltip(tooltipOptions))
});

const sortTiles = (tiles: Map<any, any>) => Array.from(tiles.values())
  .reduce(
    (sorted: { [key: number]: any[] }, tile: any) => {
      sorted[Number.parseInt(tile.typeId, 10)]
        .push(tile);
      return sorted;
    },
    {
      [tileType.INDUSTRIAL]: [],
      [tileType.VILLAGE]: [],
      [tileType.CITY]: []
    }
  );

const connector = connect(mapStateToProps, mapDispatchToProps);

const Headquarters = ({
  resources,
  tiles,
  tilePrices,
  slotPrices,
  allBuildings,
  war,
  openDialogDispatch,
  freePops
}: ConnectedProps<typeof connector>) => {
  let tilesSorted: {[key: number]: any[]} = sortTiles(tiles);
  const industrialTilesRef = useRef(null);

  useEffect(() => {
    tilesSorted = sortTiles(tiles);
    setTimeout(() => setSameHeight(industrialTilesRef.current || undefined), 750);
  }, [tiles]);

  const purchasedAllowed = (type: number) => {
    switch (type) {
      case tileType.INDUSTRIAL:
        return tilesSorted[tileType.INDUSTRIAL].length < 5
          ? resources.gold >= tilePrices[tileType.INDUSTRIAL].gold
          : resources["power-points"] >= tilePrices[tileType.INDUSTRIAL].power;
      case tileType.VILLAGE:
        return tilesSorted[tileType.VILLAGE].length < 3
          ? resources.gold >= tilePrices[tileType.VILLAGE].gold
          : resources["power-points"] >= tilePrices[tileType.VILLAGE].power;
      case tileType.CITY:
        return tilesSorted[tileType.CITY].length < 1
          ? resources.gold >= tilePrices[tileType.CITY].gold
          : resources["power-points"] >= tilePrices[tileType.CITY].power;
      default:
        return false;
    }
  }

  return (
    <>
      <h2 className="h2 h2-first">
        <span className="bordered">Industrial tiles {tilesSorted[tileType.INDUSTRIAL].length}/11</span>
      </h2>
      <section className="boxes-group">
        <span className="divider"/>
        <div className="box">
          <div className="row tile industrial" ref={industrialTilesRef}>
            <div className="col-md-12">
              {/* {tilesSorted[tileType.INDUSTRIAL].map((tile: any) => <Slot */}
              {/*    key={Object.keys(tile.slots)[0]} */}
              {/*    tileTypeId={tile.typeId} */}
              {/*    slot={Object.values(tile.slots)[0]} */}
              {/*    clicked={Object.values<any>(tile.slots)[0].typeId > 0 */}
              {/*      ? (elementRef: any) => openTooltipDispatch({ */}
              {/*        name: "BuildingInfo", */}
              {/*        dynamic: true, */}
              {/*        classes: ["full-width"], */}
              {/*        slot: Object.values(tile.slots)[0], */}
              {/*        tileTypeId: tileType.INDUSTRIAL, */}
              {/*        closeControl: true, */}
              {/*        elementRef */}
              {/*      }) */}
              {/*      : (elementRef: any) => openDialogDispatch({ */}
              {/*        slotId: Object.values<any>(tile.slots)[0].id, */}
              {/*        name: "NewBuilding", */}
              {/*        availableBuildings: tile.availableBuildings, */}
              {/*        slotPrices, */}
              {/*        classes: ["new-manor"], */}
              {/*        elementRef: elementRef.current */}
              {/*      }) */}
              {/*    } */}
              {/*  />) */}
              {/* } */}
              {tilesSorted[tileType.INDUSTRIAL].map((tile: TileType) => <SlotPerson
                key={Object.keys(tile.slots)[0]}
                tile={tile}
                slotPrices={slotPrices}
                allBuildings={allBuildings}
                slot={Object.values(tile.slots)[0]}
                freePops={freePops}
              />)
              }
            </div>
          </div>
        </div>
        {Object.values(tilePrices[tileType.INDUSTRIAL]).some((p: any) => p)
          ? <>
            <div className="box">
              <a href="#" className={`btn btn-no-height btn-blank ${war
              || !purchasedAllowed(tileType.INDUSTRIAL) ? "disabled" : ""}`}
                 onClick={event => !war && purchasedAllowed(tileType.INDUSTRIAL)
                   && openDialogDispatch({
                     name: "NewTile",
                     header: `Buy ${TILE_TYPE_NAMES[tileType.INDUSTRIAL]}`,
                     tileType: tileType.INDUSTRIAL,
                     effect: "",
                     purchaseAllowed: purchasedAllowed(tileType.INDUSTRIAL),
                     gold: (tilesSorted[tileType.INDUSTRIAL].length < 5
                       ? tilePrices[tileType.INDUSTRIAL].gold
                       : null),
                     power: (tilesSorted[tileType.INDUSTRIAL].length >= 5
                       ? tilePrices[tileType.INDUSTRIAL].power
                       : null),
                     event
                   })}
              >New industrial <br/>
              {tilesSorted[tileType.INDUSTRIAL].length < 5
                ? <>
                  <span className="no-wrap">{tilePrices[tileType.INDUSTRIAL].gold}</span>
                  &nbsp;<i className="icon icon-standalone icon-zlato gold align-sub"/>
                </>
                : <>
                  <span className="no-wrap">{tilePrices[tileType.INDUSTRIAL].power}</span>
                  &nbsp;<i className="icon icon-standalone icon-pozemky align-sub"/>
                </>
              }
              </a>
            </div>
            <span className="divider"/>
          </> : <></>}
      </section>

      <h2 className="h2">
        <span className="bordered">Village tiles {tilesSorted[tileType.VILLAGE].length}/11
        </span>
      </h2>
      <section className="boxes-group">
        <span className="divider"/>
        {tilesSorted[tileType.VILLAGE].map((tile: any) => <TileDiv key={tile.id} tile={tile} />)}

        {Object.values(tilePrices[tileType.VILLAGE]).some((p: any) => p)
          ? <div className="box">
            <a href="#" className={`btn btn-no-height btn-blank ${war
            || !purchasedAllowed(tileType.VILLAGE) ? "disabled" : ""}`}
               onClick={event => !war && purchasedAllowed(tileType.VILLAGE) && openDialogDispatch({
                 name: "NewTile",
                 header: `Buy ${TILE_TYPE_NAMES[tileType.VILLAGE]}`,
                 tileType: tileType.VILLAGE,
                 effect: `<div class="white">+2 <i class="icon icon-sm icon-zlato gold align-sub"></i> per turn</div>`,
                 purchaseAllowed: purchasedAllowed(tileType.VILLAGE),
                 gold: (tilesSorted[tileType.VILLAGE].length < 3
                   ? tilePrices[tileType.VILLAGE].gold
                   : null),
                 power: (tilesSorted[tileType.VILLAGE].length >= 3
                   ? tilePrices[tileType.VILLAGE].power
                   : null),
                 event
               })}
            >New village tile <br/>
              {tilesSorted[tileType.VILLAGE].length < 3
                ? <>
                  <span className="no-wrap">{tilePrices[tileType.VILLAGE].gold}</span>
                  &nbsp;<i className="icon icon-standalone icon-zlato gold align-sub"/>
                </>
                : <>
                  <span className="no-wrap">{tilePrices[tileType.VILLAGE].power}</span>
                  &nbsp;<i className="icon icon-standalone icon-pozemky align-sub"/>
                </>
              }
            </a>
          </div> : <></>}
        <span className="divider"/>
      </section>

      <h2 className="h2">
        <span className="bordered">City tiles {tilesSorted[tileType.CITY].length}/11
        </span>
      </h2>
      <section className="boxes-group">
        <span className="divider"/>
        {tilesSorted[tileType.CITY].map((tile: any) => <TileDiv key={tile.id} tile={tile} />)}

        {Object.values(tilePrices[tileType.CITY]).some((p: any) => p)
          ? <div className="box">
            <a href="#" className={`btn btn-no-height btn-blank ${war
            || !purchasedAllowed(tileType.CITY) ? "disabled" : ""}`}
               onClick={event => !war && purchasedAllowed(tileType.CITY) && openDialogDispatch({
                 name: "NewTile",
                 tileType: tileType.CITY,
                 header: `Buy ${TILE_TYPE_NAMES[tileType.CITY]}`,
                 effect: `<div class="white">+5 <i class="icon icon-sm icon-zlato gold align-sub"></i> per turn</div>`,
                 purchaseAllowed: purchasedAllowed(tileType.CITY),
                 gold: (tilesSorted[tileType.CITY].length < 1
                   ? tilePrices[tileType.CITY].gold
                   : null),
                 power: (tilesSorted[tileType.CITY].length >= 1
                   ? tilePrices[tileType.CITY].power
                   : null),
                 event
               })}
            >New city tile <br/>
              {tilesSorted[tileType.CITY].length < 1
                ? <>
                  <span className="no-wrap">{tilePrices[tileType.CITY].gold}</span>
                  &nbsp;<i className="icon icon-standalone icon-zlato gold align-sub"/>
                </>
                : <>
                  <span className="no-wrap">{tilePrices[tileType.CITY].power}</span>
                  &nbsp;<i className="icon icon-standalone icon-pozemky align-sub"/>
                </>
              }
            </a>
          </div> : <></>}
        <span className="divider"/>
      </section>
    </>
  );
}

export default connector(Headquarters);
